<template>
  <div class="mt-3 d-flex align-center justify-end">
    <v-pagination
      @input="changePage"
      v-if="length > 1"
      :value="value"
      :length="length"
      :total-visible="10"
    ></v-pagination>
    <div style="position: relative">
      <v-form @submit.prevent="setPage">
        <custom-input-text
          v-if="goTo && length > 5"
          class="no-margin user_input mt-1 mr-2"
          :placeholder="$t('pageCount')"
          style="max-width: 134px"
          v-model="pageCount"
        />
        <v-icon
          @click="setPage"
          v-if="pageCount"
          style="position: absolute; top: 11px; right: 15px; cursor: pointer"
          type="submit"
        >
          mdi-arrow-right-thick
        </v-icon>
      </v-form>
    </div>
    <custom-select
      style="width: 90px"
      class="user_input no-margin mt-1"
      :items="['10', '20', '50', '100']"
      :value="limit"
      @input="(val) => $emit('update:limit', val)"
      v-if="maxPage"
    />
  </div>
</template>

<script>
export default {
  name: "VuePagination",
  props: {
    limit: {
      type: [Number, String],
      default: "10",
    },
    value: {
      type: Number,
    },
    length: {
      type: Number,
      default: 0,
    },
    goTo: {
      type: Boolean,
      default: false,
    },
    maxPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageCount: null,
    };
  },
  methods: {
    changePage(val) {
      if (this.value !== val) {
        this.$emit("input", val);
      }
    },
    setPage() {
      if (!isNaN(this.pageCount) && this.length >= this.pageCount) {
        if (this.pageCount) this.changePage(+this.pageCount);
      }
    },
  },
};
</script>
